import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import styles from './LegalPage.module.css';

export default function LegalPage() {
  return (
    <div className={styles.container}>
      <Link to="/" className={styles.backLink}>
        <ArrowLeft size={20} />
        Back to Home
      </Link>
      
      <h1 className={styles.title}>Legal Information</h1>
      
      <div className={styles.content}>
        <section className={styles.section}>
          <h2>Health & Nutrition Disclaimer</h2>
          <p>
            The information provided by this app, including meal suggestions, calorie estimates, nutrition information, and lifestyle guidance, is for educational and informational purposes only and is not intended as medical advice.
          </p>
          <p>
            This app does not diagnose, treat, cure, or prevent any disease or medical condition, including diabetes or other metabolic conditions. Always consult a qualified healthcare professional before making changes to your diet, exercise routine, or lifestyle, especially if you have a medical condition, are pregnant, or are taking prescription medications.
          </p>
          <p>Individual results may vary.</p>
        </section>

        <section className={styles.section}>
          <h2>Personalization & Recommendation Disclaimer</h2>
          <p>
            Recommendations provided by this app are based solely on the information you choose to enter, such as sex, weight, age, and activity level. These recommendations are intended to offer general guidance only and may not be accurate or appropriate for all individuals.
          </p>
          <p>
            The app does not account for all possible health factors, medical conditions, or individual needs and should not be relied upon as professional or medical advice.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Nutrition Information Disclaimer</h2>
          <p>
            Calorie and nutritional values shown in this app are estimates only and may vary based on ingredients, preparation methods, portion sizes, product brands, and individual metabolism.
          </p>
          <p>
            Nutrition information should not be used as a substitute for professional dietary or medical advice.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Safety Notice</h2>
          <p>
            This app is not intended for use in medical emergencies or for managing serious medical conditions without professional supervision. If you have concerns about your health or experience a medical emergency, seek immediate assistance from a qualified healthcare provider or emergency services.
          </p>
        </section>

        <section className={styles.section}>
          <h2>No Guarantees</h2>
          <p>
            The app does not guarantee any specific health, fitness, or nutritional outcomes. Individual results will vary based on many factors, including personal habits, consistency, and individual circumstances.
          </p>
        </section>

        <section className={styles.section}>
          <h2>User Responsibility</h2>
          <p>
            By using this app, you acknowledge and agree that you are responsible for your own health decisions. You agree to use the information provided at your own discretion and understand that the app is intended solely as a general educational resource.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Terms of Service</h2>
          <p>
            By using this app, you agree to be bound by our Terms of Service, which govern your use of the app, subscriptions, and related services.
          </p>
          <p>
            <a href="https://peapilpublishing.com/policies/terms-of-service" target="_blank" rel="noopener noreferrer" className={styles.externalLink}>
              View Terms of Service
            </a>
          </p>
        </section>

        <section className={styles.section}>
          <h2>Privacy Policy</h2>
          <p>
            We respect your privacy. Our Privacy Policy explains what information we collect, how it is used, how it is protected, and your rights regarding your personal data.
          </p>
          <p>
            <Link to="/privacy" className={styles.externalLink}>View Privacy Policy</Link>
          </p>
        </section>

        <section className={styles.section}>
          <h2>Contact Information</h2>
          <p>
            If you have questions about this Legal page, the app, or your account, please contact us at:
          </p>
          <p>
            Email: <a href="mailto:support@peapilhealth.com" className={styles.emailLink}>support@peapilhealth.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
